import { useEffect, useState } from "react";
import { apiUrl } from "../ApiUrl/ApiUrl";
import { Box, Flex } from "@chakra-ui/react";
import AdminSidebar from "./AdminSidebar";
import { Select } from "chakra-react-select";

const CreateInvoice = () => {

  const personName =localStorage.getItem("loginsetName");
  const [invoices, setInvoices] = useState([]);
  useEffect(() => {
    fetchInvoices();
  }, []);
const uid = localStorage.getItem("uid")
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // Filter invoices based on search query (Order ID or Customer Name)
  const filteredInvoices = invoices.filter(
    (invoice) =>
      invoice.orderId.toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
      invoice.invoiceid.toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
      invoice.cname.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Pagination logic (only paginate filtered results)
  const totalPages = Math.max(1, Math.ceil(filteredInvoices.length / recordsPerPage));

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredInvoices.slice(indexOfFirstRecord, indexOfLastRecord);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const generateOrderId = () => {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let orderId = "ORD-";
    for (let i = 0; i < 6; i++) {
      orderId += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return orderId;
  };
  const [formData, setFormData] = useState(() => ({
    invoiceid:"",
    orderId: generateOrderId(), // Wrap inside an arrow function
    cname: "",
    address: "",
    city: "",
    state: "",
    email: "",
    contactNumber: "",
    description: "",
    remark:"",
    invcreatedby: personName,
    pincode: "",
    totalAmount: "",
    dateadded: "", // Optional: User can enter manually
    items: [{ bookTitle: "", itemPrice: "", gst: "", qty: "" ,hsn:"" ,includeGST: false}],
  }));
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // const handleItemChange = (index, e) => {
  //   const { name, value } = e.target;
  //   const updatedItems = [...formData.items];
  //   updatedItems[index][name] = value;
  //   setFormData({ ...formData, items: updatedItems });
    
  // };
  const handleItemChange = (index, e) => {
    const { name, value } = e.target;
    const updatedItems = [...formData.items];
    updatedItems[index][name] = value;

    if (name === "bookTitle") {
      // Find the selected book data by its title
      const selectedBook = allBooks.find((book) => book.booktitle === value);

      if (selectedBook) {
        // Fill in price, hsn, etc. based on the selected book
        updatedItems[index].itemPrice = selectedBook.mainprice || "";
        updatedItems[index].hsn = selectedBook.hsn || "";
      }
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      items: updatedItems
    }));
  };

  const addItem = () => {
    setFormData({
      ...formData,
      items: [...formData.items, { bookTitle: "", itemPrice: "", gst: "", qty: "",hsn: "",includeGST: false }],
    });
  };

  const removeItem = (index) => {
    const updatedItems = [...formData.items];
    updatedItems.splice(index, 1);
    setFormData({ ...formData, items: updatedItems });
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  
  //   const payload = { ...formData, dateadded: formData.dateadded || null };
  
  //   try {
  //     const response = await fetch(`${apiUrl}/public/create-invoice`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(payload),
  //     });
  
  //     if (response.ok) {
  //       alert("Invoice Saved Successfully!");
  //       fetchInvoices(); // Refresh invoices after saving
  
  //       setFormData({
  //         orderId: generateOrderId(), // Fix: Generate new order ID
  //         cname: "",
  //         address: "",
  //         city: "",
  //         state: "",
  //         email: "",
  //         contactNumber: "",
  //         pincode: "",
  //         totalAmount: "",
  //         dateadded: "",
  //         items: [{ bookTitle: "", itemPrice: "", gst: "", qty: "" }],
  //       });
  //     } else {
  //       alert("Failed to save invoice.");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     alert("Error saving invoice.");
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const payload = { ...formData, dateadded: formData.dateadded || null ,invcreatedby: formData.invcreatedby || personName};
  
    try {
      const isUpdating = !!formData.invoiceid;
      const url = isUpdating
        ? `${apiUrl}/public/updatebyid`
    : `${apiUrl}/public/create-invoice-admin?uid=${uid}`;
  
      const response = await fetch(url, {
        method: isUpdating ? "PUT" : "POST", // Use PUT for updates, POST for new invoices
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
  
      if (response.ok) {
        alert(isUpdating ? "Invoice Updated Successfully!" : "Invoice Saved Successfully!");
        fetchInvoices(); // Refresh invoices after saving/updating
  
        setFormData({
          invoiceid: "", // Reset invoice ID after update
          orderId: generateOrderId(), // Generate new order ID for new invoices
          cname: "",
          address: "",
          city: "",
          state: "",
          email: "",
          contactNumber: "",
          pincode: "",
          remark: "",
          invcreatedby: personName,
          description: "",
          totalAmount: "",
          dateadded: "",
          items: [{ bookTitle: "", itemPrice: "", gst: "", qty: "" ,hsn:"", includeGST: false}],
        });
      } else {
        alert(isUpdating ? "Failed to update invoice." : "Failed to save invoice.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Error processing invoice.");
    }
  };
  
  
  const fetchInvoices = async () => {
    try {
      const response = await fetch(`${apiUrl}/public/getall-invoice`);
      if (response.ok) {
        const data = await response.json();
        setInvoices(data);
      }
    } catch (error) {
      console.error("Error fetching invoices:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/public/delete-invoice?id=${id}`, {
        method: "DELETE",
      });
      if (response.ok) {
        alert("Invoice deleted successfully");
        fetchInvoices();
      } else {
        alert("Failed to delete invoice");
      }
    } catch (error) {
      console.error("Error deleting invoice:", error);
    }
  };

  const handleEdit = (invoice) => {
    setFormData(invoice);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
const handleView = (invoice) => {
  // window.open(`http://localhost:3001/invoiceadmin?orderId=${invoice}`, '_blank');
  window.open(`https://navneetlawstudio.com/invoiceadmin?orderId=${invoice}`, '_blank');
  window.scrollTo({ top: 0, behavior: 'smooth' });
};
  // function calc(index) {
  //   let updatedItems = [...formData.items];
  
  //   let a = parseFloat(updatedItems[index].itemPrice) || 0;
  //   let b = parseFloat(updatedItems[index].gst) || 0; // Now correctly updates from dropdown
  //   let c = parseFloat(updatedItems[index].qty) || 0;
  
  //   let gstAmount = (a * c) * b; // GST calculation
  //   let totalAmount = (a * c) + gstAmount; // Total after adding GST
  
  //   updatedItems[index].gstAmount = gstAmount.toFixed(2);
  //   updatedItems[index].total = totalAmount.toFixed(2);
  
  //   setFormData({ ...formData, items: updatedItems });
  // }
  
  // const calc = (index) => {
  //   let updatedItems = [...formData.items];
  //   let item = updatedItems[index];
  
  //   // Calculate GST amount
  //   let gstAmount = (item.qty * item.itemPrice * item.gst).toFixed(2);
  //   item.gstAmount = gstAmount;
  
  //   // Calculate total for this row
  //   let total = (item.qty * item.itemPrice + parseFloat(gstAmount)).toFixed(2);
  //   item.total = total;
  
  //   updatedItems[index] = item;
  
  //   // Calculate grand total (sum of all row totals)
  //   let grandTotal = updatedItems.reduce((sum, i) => sum + parseFloat(i.total || 0), 0).toFixed(2);
  
  //   setFormData({ ...formData, items: updatedItems, totalAmount: grandTotal });
  // };
  const calc = (index) => {
    let updatedItems = [...formData.items];
    let item = updatedItems[index];
  
    const qty = parseFloat(item.qty) || 0;
    const price = parseFloat(item.itemPrice) || 0;
    const gstRate = parseFloat(item.gst) || 0;
  
    let gstAmount = (price * qty * gstRate).toFixed(2);
    let total = (price * qty + parseFloat(gstAmount)).toFixed(2);
  
    item.gstAmount = gstAmount;
    item.total = total;
  
    updatedItems[index] = item;
  
    const grandTotal = updatedItems
      .reduce((sum, i) => sum + parseFloat(i.total || 0), 0)
      .toFixed(2);
  
    setFormData({ ...formData, items: updatedItems, totalAmount: grandTotal });
  };
  
  
  
 
  const [states, setStates] = useState([]);
  useEffect(() => {
      const allStatesAndUTs = [
          // States
          "Andhra Pradesh",
          "Arunachal Pradesh",
          "Assam",
          "Bihar",
          "Chhattisgarh",
          "Goa",
          "Gujarat",
          "Haryana",
          "Himachal Pradesh",
          "Jharkhand",
          "Karnataka",
          "Kerala",
          "Madhya Pradesh",
          "Maharashtra",
          "Manipur",
          "Meghalaya",
          "Mizoram",
          "Nagaland",
          "Odisha",
          "Punjab",
          "Rajasthan",
          "Sikkim",
          "Tamil Nadu",
          "Telangana",
          "Tripura",
          "Uttarakhand",
          "Uttar Pradesh",
          "West Bengal",

          // Union Territories
          "Andaman and Nicobar Islands",
          "Chandigarh",
          "Dadra and Nagar Haveli and Daman & Diu",
          "Delhi (NCT)",
          "Jammu & Kashmir",
          "Ladakh",
          "Lakshadweep",
          "Puducherry"
      ];

      setStates(allStatesAndUTs);
  }, []);



const [allBooks, setAllBooks] = useState([]);

useEffect(() => {
  const fetchBooks = async () => {
    const response = await fetch(`${apiUrl}/public/allbooks`);
    const data = await response.json();
    setAllBooks(data);
  };

  fetchBooks();
}, []);
useEffect(() => {
  setFormData((prev) => ({
    ...prev,
    invcreatedby: personName
  }));
}, [personName]);
  return (
    <>
  
     <Flex h="100%" bg="gray.100">
          <AdminSidebar />
          <Box flex="1" >

      

    <div className="max-w-6xl mx-auto  p-6 bg-white shadow-lg rounded-lg">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Create Invoice</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <input required type="text" name="cname" placeholder="Customer Name" value={formData.cname} onChange={handleChange} className="input-field border border-gray-300 p-2 rounded-md w-full" />
          <input required type="date" name="dateadded" placeholder="Date (Optional)" value={formData.dateadded} onChange={handleChange} className="input-field border border-gray-300 p-2 rounded-md w-full" />
          <input type="text" name="address" placeholder="Address" value={formData.address} onChange={handleChange} className="input-field border border-gray-300 p-2 rounded-md w-full col-span-2" />
          <input type="text" name="city" placeholder="City" value={formData.city} onChange={handleChange} className="input-field border border-gray-300 p-2 rounded-md w-full" />
          {/* <input required type="text" name="state" placeholder="State" value={formData.state} onChange={handleChange} className="input-field border border-gray-300 p-2 rounded-md w-full" /> */}
        
          <Select
  value={formData.state ? { label: formData.state, value: formData.state } : null}
  onChange={(selectedOption) =>
    setFormData({ ...formData, state: selectedOption.value })
  }
  options={states.map((state) => ({ label: state, value: state }))}
  placeholder="Select State"
/>

        
          <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} className="input-field border border-gray-300 p-2 rounded-md w-full" />
      <input  type="text" name="contactNumber" placeholder="Contact Number" value={formData.contactNumber} onChange={handleChange} className="input-field border border-gray-300 p-2 rounded-md w-full" minLength="10" maxLength="10" pattern="[0-9]{10}" title="Please enter a 10 digit contact number" onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()} />
       
          <input 
  required 
  type="number" 
  name="totalAmount" 
  placeholder="Total Amount" 
  value={formData.totalAmount} 
  readOnly  // Make it read-only so users can't edit manually
  className="input-field border border-gray-300 p-2 rounded-md w-full" 
/>

<input type="text" name="remark" placeholder="remark" value={formData.remark} onChange={handleChange} className="input-field border border-gray-300 p-2 rounded-md w-full" />
<input type="hidden" name="invcreatedby"  value={formData.invcreatedby} onChange={handleChange} className="input-field border border-gray-300 p-2 rounded-md w-full" />
          <input type="text" name="description" placeholder="description" value={formData.description} onChange={handleChange} className="input-field border border-gray-300 p-2 rounded-md w-full" />

        </div>

        <h3 className="text-xl font-semibold mt-6">Invoice Items</h3>
<div className="grid grid-cols-7 gap-4 font-semibold mt-2">
  <span>Item Name</span>
  <span>Quantity</span>
  <span>Price/item</span>
  <span >Select gst</span>
  <span hidden>HSN Code</span>
  <span>Included GST</span>
  <span>GST</span>
  <span>total</span>


</div>
{formData.items.map((item, index) => (
  <div key={index} className="grid grid-cols-7 gap-4 items-center">
    {/* <input 
      required 
      type="text" 
      name="bookTitle" 
      placeholder="Item name" 
      value={item.bookTitle} 
      onChange={(e) => handleItemChange(index, e)} 
      className="input-field" 
    /> */}
 <Select
  name="bookTitle"
  value={
    item.bookTitle
      ? { label: item.bookTitle, value: item.bookTitle }
      : null
  }
  onChange={(selectedOption) => handleItemChange(index, {
    target: { name: 'bookTitle', value: selectedOption?.value || '' }
  })}
  options={allBooks.map(book => ({
    label: book.booktitle,
    value: book.booktitle
  }))}
  placeholder="Select a book"
  isClearable
  isSearchable
  
/>

 

    <input 
      id={`qty-${index}`} 
      required 
      type="number" 
      name="qty"  
      placeholder="Quantity" 
      value={item.qty} 
      onChange={(e) => {
        handleItemChange(index, e);
        calc(index); // Call calc when quantity changes
      }} 
      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" 

    />

    {/* <input 
      required 
      type="number" 
      name="itemPrice" 
      placeholder="Price/item" 
      value={formData.items[0].itemPrice}
      onChange={(e) => {
        handleItemChange(index, e);
        calc(index); // Call calc when price changes
      }}  
    /> */}
  <input 
  required 
  type="number" 
  name="itemPrice" 
  placeholder="Price/item" 
  value={item.itemPrice}
  onChange={(e) => {
    let updatedItems = [...formData.items];
    let enteredPrice = parseFloat(e.target.value) || 0;
    const gstRate = parseFloat(item.gst) || 0;

    if (item.includeGST && gstRate > 0) {
      // GST included: convert to base price
      updatedItems[index].itemPrice = (enteredPrice / (1 + gstRate)).toFixed(2);
    } else {
      // Excluded: keep as is
      updatedItems[index].itemPrice = enteredPrice;
    }

    setFormData({ ...formData, items: updatedItems });
    calc(index);
  }}  
  className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" 

/>



{/* <select 
  required 
  id={`selectgst-${index}`}  
  value={item.gst} // Ensure the select dropdown reflects the correct value
  onChange={(e) => {
    let updatedItems = [...formData.items];
    updatedItems[index].gst = parseFloat(e.target.value) || 0; // Update GST value
    setFormData({ ...formData, items: updatedItems });
    calc(index); // Recalculate totals after updating GST
  }}
>
  <option value="0">0%</option>
  <option value="0.05">5%</option>
  <option value="0.12">12%</option>
  <option value="0.18">18%</option>
</select> */}

<select 
 className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" 

  required 
  value={item.gst}
  onChange={(e) => {
    let updatedItems = [...formData.items];
    updatedItems[index].gst = parseFloat(e.target.value) || 0;
    setFormData({ ...formData, items: updatedItems });
    calc(index); // Recalculate totals
  }}
>
  <option value="0">0%</option>
  <option value="0.05">5%</option>
  <option value="0.12">12%</option>
  <option value="0.18">18%</option>
</select>
<input 
       
      type="hidden" 
      name="hsn" 
      placeholder="HSN Code" 
      value={formData.items[0].hsn}
      onChange={(e) => handleItemChange(index, e)} 
      className="input-field" 
    />
        {/* Include/Exclude GST toggle */}
        <label className="flex items-center space-x-2">
        <input
  type="checkbox"
  checked={item.includeGST}
  disabled={!item.gst || parseFloat(item.gst) === 0} // Disable if GST is 0 or not selected
  onChange={(e) => {
    let updatedItems = [...formData.items];
    updatedItems[index].includeGST = e.target.checked;

    const gstRate = parseFloat(item.gst) || 0;
    const currentPrice = parseFloat(item.itemPrice) || 0;

    if (e.target.checked && gstRate > 0) {
      updatedItems[index].itemPrice = (currentPrice / (1 + gstRate)).toFixed(2);
    } else if (!e.target.checked && gstRate > 0) {
      updatedItems[index].itemPrice = (currentPrice * (1 + gstRate)).toFixed(2);
    }

    setFormData({ ...formData, items: updatedItems });
    calc(index); // Recalculate
  }}
/>

</label>


    <input 
      readOnly  
      id={`gst-${index}`} 
      required 
      type="number" 
      name="gstAmount" 
      placeholder="GST" 
      value={item.gstAmount} 
      className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" 

    />

   <input 
  id={`total-${index}`} 
  readOnly 
  required 
  type="number" 
  name="total" 
  placeholder="Total" 
  value={Math.round(item.total)} 
  className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" 
/>

  
    {index > 0 && (
      <button type="button" onClick={() => removeItem(index)} className="text-red-600 font-bold">
        Remove
      </button>
    )}
  </div>
))}


        <button type="button" onClick={addItem} className="text-blue-600 font-bold">+ Add Item</button>

        <button type="submit" className="w-full bg-blue-600 text-white p-3 rounded-md font-bold mt-4">Submit Invoice</button>
      </form>
    </div>
    </Box>

    
    </Flex>

    <Box flex="1">
    <div className="mx-auto mt-10 p-6 bg-white shadow-lg rounded-lg">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Invoices</h2>
<div className="flex  gap-10">
   {/* Search Input */}
   <input
        type="text"
        placeholder="Search by Order ID or Customer Name or Invoice Number..."
        className="w-10/12 p-2 border border-gray-300 rounded mb-4"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
<h1 className="content-center ">Total Invoices : {filteredInvoices.length}</h1>

</div>
     

      {/* Table */}
  {/* Table */} 
{filteredInvoices.length > 0 ? (
  <table className="w-full border-collapse border border-gray-300">
    <thead>
      <tr className="bg-gray-200">
        <th className="border p-2">Invoice No</th>
        <th className="border p-2">Order ID</th>
        <th className="border p-2">Customer Name</th>
        <th className="border p-2">Total Amount</th>
        <th className="border p-2">Created By</th>
        <th className="border p-2">Actions</th>
      </tr>
    </thead>
    <tbody>
      {currentRecords.length > 0 ? (
        currentRecords.map((invoice) => (
          <tr key={invoice.orderId} className="text-center">
            <td className="border p-2">{invoice.invoiceid}</td>
            <td className="border p-2">{invoice.orderId}</td>
            <td className="border p-2">{invoice.cname}</td>
            <td className="border p-2">{invoice.totalAmount}</td>
            <td className="border p-2">{invoice.invcreatedby}</td>

            <td className="border p-2">
              <button className="text-blue-600 font-bold mr-2" onClick={() => handleView(invoice.orderId)}>
                View
              </button>
              <button className="text-blue-600 font-bold mr-2" onClick={() => handleEdit(invoice)}>
                Edit
              </button>
              <button className="text-red-600 font-bold" onClick={() => handleDelete(invoice.invoiceid)}>
                Delete
              </button>
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="4" className="border p-2 text-center text-gray-500">0 results found</td>
        </tr>
      )}
    </tbody>
  </table>
) : (
  <p className="text-center text-gray-500 mt-4">0 results found</p>
)}


      {/* Pagination Controls */}
      <div className="flex justify-center items-center mt-4 space-x-2">
        <button
          className="px-3 py-1 border rounded bg-gray-200"
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
        >
          Prev
        </button>

        {[...Array(totalPages)].map((_, index) => (
          <button
            key={index}
            className={`px-3 py-1 border rounded ${
              currentPage === index + 1 ? "bg-blue-500 text-white" : "bg-gray-200"
            }`}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </button>
        ))}

        <button
          className="px-3 py-1 border rounded bg-gray-200"
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Next
        </button>
      </div>
    </div>
</Box>


</>
  );
};

export default CreateInvoice;
